/* istanbul ignore file */
import { connect } from 'react-redux'
import { navigateTo } from 'rental-car-contract/js/actions/navigation'
import Routes from 'commons/js/routes/routes'
import Summary from './Summary'
import { isWebview } from '@elparking/utils'

function mapStateToProps (state) {
    return {}
}

function mapDispatchToProps (dispatch) {
    return {
        goToRentalCarLanding () {
            dispatch(navigateTo({
                url: isWebview() ? Routes.rentalCarSitePathMobile({ isCancelled: true }) : Routes.rentalCarSitePath({}),
            }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Summary)
